import React, { FunctionComponent } from 'react'
import QuizzLogo from './QuizzLogo'
import { tt } from '../../../i18n'
import WheelButton from '../../../components/cta/WheelButton'
import { QuizzGift } from '@tootsweet/model/lottery/Quizz'
import { useSelector } from 'react-redux'
import { quizzSelector, scoreSelector } from '../../../redux/selectors/quizz'

interface Props {
  onGiftChosen: (gift: QuizzGift) => void
  getGiftsThatApply: () => QuizzGift[]
}

const QuizzEnd: FunctionComponent<Props> = ({
  onGiftChosen,
  getGiftsThatApply,
}) => {
  const score = useSelector(scoreSelector)
  const quizz = useSelector(quizzSelector)

  const giftsThatApply = getGiftsThatApply()

  return (
    <>
      {/*{renderLogo("logo-container-centered", true)}*/}
      <QuizzLogo containerClass={'logo-container-centered'} useConfig={true} />

      {giftsThatApply.length === 0 && (
        <div className="row w-margin-bottom w-margin-top">
          <div className="col s12">
            <h2 className="h2 text-center">
              {quizz?.winScore !== -1
                ? tt('quizz_no_good_answer')
                : tt('quizz_not_enough_points_1')}
            </h2>
          </div>
        </div>
      )}

      {giftsThatApply.length === 0 && (
        <div id="end-announcement" className="row w-margin-bottom text-center">
          <div className="col s12">
            <p>{tt('quizz_not_enough_points_2')}</p>
          </div>
        </div>
      )}

      {giftsThatApply.length > 0 && (
        <div className="row w-margin-bottom">
          <div className="col s12">
            <h2 className="h2 text-center">
              {tt('quizz_score', {
                score: score,
                pointsStr: score > 1 ? 'points' : 'point',
              })}
            </h2>
          </div>
        </div>
      )}

      {giftsThatApply.length > 0 && (
        <>
          <div
            id="end-announcement"
            className="row w-margin-bottom text-center"
          >
            <div className="col s12">
              <p>{tt('quizz_enough_points')}</p>
            </div>
          </div>

          <div className="row w-margin-bottom text-center">
            <div className="col s12">
              {giftsThatApply.length > 0 &&
                giftsThatApply.map((gift, idx) => {
                  return (
                    <div key={`gift-${idx}`} className="quizz-gift-container">
                      <WheelButton
                        text={gift.label}
                        onClick={() => onGiftChosen(gift)}
                      />
                    </div>
                  )
                })}
              {giftsThatApply.length === 0 && (
                <span>{tt('quizz_you_won_nothing')}</span>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default QuizzEnd
